module.exports = __webpack_public_path__ + "img/icon_friend.d2ed0e7c.png";